module.exports = __webpack_public_path__ + "img/20.6bdff323.png";